import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout, isAdmin } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      logout();
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-title">
          <h1 className="welcome-text">Bonjour{user?.firstName ? `, ${user.firstName}` : ''} </h1>
          <p className="welcome-subtitle">Bienvenue sur votre espace de gestion</p>
        </div>
        
        <div className="header-actions">
          
          <div className="user-profile">
            <div className="user-avatar">
              {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
            </div>
            
            <div className="user-info">
              <span className="user-name">{user?.firstName} {user?.lastName}</span>
              <span className="user-role">
                {isAdmin ? '👑 Administrateur' : '👤 Utilisateur'}
              </span>
            </div>
            
            <button onClick={handleLogout} className="logout-btn">
              <span className="logout-icon"></span>
              Déconnexion
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;